import React from 'react';

const RadioButton = ({ label, value, checked, onChange }) => {
    return (
        <label className="flex items-center space-x-2">
            <input
                type="radio"
                value={value}
                checked={checked}
                onChange={onChange}
                className="hidden"
            />
            <div
                className={`w-6 h-6 flex items-center justify-center border rounded-full ${checked ? 'border-gray-1 bg-blue-1' : 'border-gray-400 bg-white'
                    }`}
            >
                {checked && <div className="w-2 h-2 bg-white-0 rounded-full"></div>}
            </div>
            <span>{label}</span>
        </label>
    );
};

export default RadioButton;
